export * from './cover-page'
export * from './ProductPage'
export * from './watermark'
// export * from './theory'
// export * from './ysl'
export * from './ProductCardPdf'
export * from './ReportPage'
export * from './vlp'
export * from './restoration-hardware'

import ProductCardPdf from './ProductCardPdf'
export {ProductCardPdf}


// WEBPACK FOOTER //
// ./src/modules/pdf/templates/index.ts